import { ADD_LIST } from '../actionTypes'

export const addList = (data: object) => ({
  type: ADD_LIST.name,
  api: {
    url: 'guests/add_list',
    data: data,
  },
})
